/**
 * Created by Miguel on 23/05/2017
 */// Exemplo de estrutura de dados da lista
 interface Lista {
  id: string;
  name: string;
  cards: Card[];
}

// Exemplo de estrutura de dados do card
interface Card {
  id: string;
  name: string;
  description: string;
}

import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, } from '@angular/core';
import { UserService } from "../../../services/user.service";
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from "@angular/router";
import { AppDataService } from '../../../services/app-data.service';
import { CompanyService } from '../../../services/company.service';
import { RecipeBean } from "../../../beansts/recipe.bean"
import { ItemBean } from '../../../beansts/item.bean';
import { WalletService } from '../../../services/wallet.services';
import { TranslationService } from '../../../services/translation.service';
import { FormBuilder, FormGroup } from "@angular/forms";
import { Door } from '../../../beansts/itens/door.bean';

declare var $: any;
declare var Swal: any

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'item-manipulation-modal',
  templateUrl: 'item-manipulation-modal.html',
  providers: [],
})
export class ItemManipulationModal implements OnInit {
  public list;
  public message;
  public itemImages = []
  public itemVideos = []
  public itemAudios = []


  public openModal

  public dresses = []

  public myMission;
  public colours = []
  public isTrello=false;
  public isShopify=false;

  public writs=[]
  public jobs = []
  public selectedMissionAction = 0

  public checkList;
  public job;
  public jobKind;

  public textInfo = "Coletando textura do seu item...aguarde";
  public loading = true;
  public item;



  public canCollect = true;
  public zForm: FormGroup;
  public textForm: FormGroup;


  public sitOr = "NE";


  public boards: any[] = [];
  public shopifyBoards:any[] =[];
  public selectedBoardId: string | null = null;
  public lists: any[] = [];

  public availablePacks;
  public selectedPack;
  public icons;
  public images;
  public models;
  public animations;

  public nfts;
  public txtParam;
  static selectedList: any;
  static selectedBoardId: any;
  selectedListId: any;
  selectListId: any;
  public spaceItens=[];
  public spaceIndex=0;
  public next(){
    this.spaceItens[this.spaceIndex]=this.item;
    this.spaceIndex++;
    if (this.spaceIndex>=this.spaceItens.length){
      this.spaceIndex=0;
    }
    this._appData.object=this.spaceItens[this.spaceIndex]
    this.reloadData();

  }
  public last(){
    this.spaceItens[this.spaceIndex]=this.item;
    this.spaceIndex--;
    if (this.spaceIndex<0){
      this.spaceIndex=this.spaceItens.length;
    }
    this._appData.object=this.spaceItens[this.spaceIndex]
    this.reloadData();
  }
  public ngOnInit(): any {

    this.zForm = this.fb.group({
      xIndex: 0,
      yIndex: 0,
      zIndex: 0,
      rxIndex: 0,
      ryIndex: 0,
      rzIndex: 0,
      dxIndex: 0,
      dyIndex: 0,
      dzIndex: 0,
      sxIndex: 0,
      syIndex: 0,
      szIndex: 0,
      name:''
    });
    this.textForm = this.fb.group({
      txtParam: ''
    });
    

    $('#itemEmbed').attr('src', '');

    if (this._appData.room){
      if (this._appData.room.background2d && this._appData.room.background2d.length>0){
        this.is2D=true
      }
      else{
        this.is2D=false;
      }
    }

  }
  public is2D;
  public getImageFromItem(item){
    let thumb=item.thumbnail;
    if (thumb){
      if (thumb.indexOf('http')==0){return thumb}
      let parts=item.thumbnail.split('-')     
      if (parts[0]=='pack'){
        let packId=parts[1];
        let idx=parts[3]
        let kind=parts[2] 
        let filt=this._appData.room.packs[packId]['icons'].filter(v=>{
          return v.id==idx;
        })
        if (filt[0]){
          thumb=filt[0]['i2d'] ? filt[0]['i2d'] : filt[0]['i3d'] 
        }
        else{
           let filt=this._appData.room.packs[packId]['images'].filter(v=>{
            return v.id==idx;
          })
          if (filt[0]){
            thumb=filt[0]['url'] 
          }
          else{
            thumb=''
          }
        }
      }
      else{
        try{
        let idx=parts[1]
        let kind=parts[0] 
        let filter=this._appData.room.textures.icons.filter(v=>{
          return v.id==idx
        })
        if (filter[0]){
          thumb=filter[0].i2d 
        }
        else{
          let filter=this._appData.room.textures.images.filter(v=>{
            return v.id==idx
          })
          if (filter[0]){
            thumb=filter[0].url
          }
          else {thumb=''}

        }
        }
        
        catch(e){}
      }

    }
    else if (item.model){
      if (item.model.indexOf('http')==0){return item.model}

      let parts=item.model.split('-')     
      if (parts[0]=='pack'){
        let packId=parts[1];
        let idx=Number(parts[3])
        let filt=this._appData.room.packs[packId]['models'].filter(v=>{
          return v.id==idx;
        })
        thumb=filt[0] ? filt[0].img : ''
      }
      else{
        let idx=parts[1]
        try {
          let filter=this._appData.room.textures.models.filter(v=>{
              return v.id==idx
            })
            thumb=filter[0].img
          }
          catch (err){
            thumb=this._appData.room.textures.models[idx].img 
          }
      }
    }
    return thumb;

  }
  public triggerReload(){
    this.item.triggers=this._appData.triggers;
    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId.toString()).set(this.item)
  }
  public selectAvailablePack(packId: string): void {
    this.icons=[]
    this.images=[]
    this.models=[]
    this.animations=[]
    this.selectedPack = this.availablePacks.find(pack => pack.id === packId);
    if (!this.selectedPack){
      //no pack use my textures
      if (this._appData.room.textures) {
        this.icons = []
        if (!this._appData.room.textures.icons) {this._appData.room.textures.icons=[]}
          this._appData.room.textures.icons.forEach(ic => {
            let icon = {
              i2d: ic.i2d,
              id:ic.id,
              name:ic.name,
              selected: false
            }
            if (this.item.thumbnail == "i3d-"+ic.id) {
              icon.selected = true;
            }
            this.icons.push(icon);  
          })
          this.icons.push({i2d:'assets/game-ui/medias/13916632.png',id:'NEWICON',name:'Novo Icone',selected:false})         
        if (!this._appData.room.textures.images) {this._appData.room.textures.images=[]}
          this._appData.room.textures.images.forEach(ic => {
            let image = {
              url: ic.url,
              id:ic.id,
              name:ic.name,
              selected: false
            }
            if (this.item.thumbnail == "img-"+ic.id) {
              image.selected = true;
            }
            this.images.push(image);            
          })
          this.images.push({url:'assets/game-ui/medias/12712143.png',id:'NEWIMAGE',name:'Nova Imagem',selected:false})         

        if (this._appData.room.textures.models) {
          this._appData.room.textures.models.forEach(ic => {
            let model = {
              img: ic.img,
              model:ic.model,
              name:ic.name,
              selected: false,
              id:ic.id
            }
            if (this.item.model == "model-"+ic.id) {
              model.selected = true;
            }
            this.models.push(model);
          })
        }  
        if (this._appData.room.textures.animation) {
          this._appData.room.textures.animation.forEach(ic => {
            let animation = {
              img: ic.img,
              model:ic.model,
              name:ic.name,
              selected: false,
              id:ic.id
            }
            if (this.item.animation == "animation-"+ic.id) {
              animation.selected = true;
            }
            this.animations.push(animation);
          })
        }              
      }
  
    }
    else{
      //has pack use pack
        this.icons = []
        if (this.selectedPack.icons) {
          this.selectedPack.icons.forEach(ic => {
            let icon = {
              i2d: ic.i2d,
              name:ic.name,
              selected: false
            }
            if (this.item.thumbnail == 'pack-'+this.selectedPack.id+'-i3d-'+ic.id) {
              icon.selected = true;
            }
            if (this.item.thumbnail == 'pack-'+this.selectedPack.id+'-i2d-'+ic.id) {
              icon.selected = true;
            }

            this.icons.push(icon);
          })
        }
        if (this.selectedPack.images) {
          this.selectedPack.images.forEach(ic => {
            let image= {
              url: ic.url,
              name:ic.name,
              selected: false
            }
            if (this.item.thumbnail == 'pack-'+this.selectedPack.id+'-img-'+ic.id) {
              image.selected = true;
            }
            this.images.push(image);
          })
        }        
        if (this.selectedPack.models) {
          this.selectedPack.models.forEach(ic => {
            let model = {
              img: ic.img,
              model:ic.model,
              name:ic.name,
              selected: false
            }
            if (this.item.model == 'pack-'+this.selectedPack.id+'-model-'+ic.id) {
              model.selected = true;
            }
            this.models.push(model);
          })
             
        }  
        if (this.selectedPack.animations) {
          this.selectedPack.animations.forEach(ic => {
            let animation = {
              img: ic.img,
              model:ic.model,
              name:ic.name,
              selected: false
            }
            if (this.item.animation == 'pack-'+this.selectedPack.id+'-animation-'+ic.id) {
              animation.selected = true;
            }
            this.animations.push(animation);
          })
             
        }               
    }
  }

  public deleteItem(){
    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId).delete().then(v=>{
      $('#itemManipulationModal').modal('hide')
    })
  }
  public reloadData() {
    this.icons = []
    this.images=[]
    this.itemImages = []
    this.selectedPack=null;
    let item = this._appData.object;
    this.item = item;
    let modal=document.getElementById("itemManipulationModal")
    try{
      modal.addEventListener('hidden.bs.modal', () => {
            const event = new CustomEvent('angularMessage',{detail:{ kind: 'itemEdit', value: false }});
            window.dispatchEvent(event);
      });
      this.sendIframeMessage({ kind: 'itemEdit', value: true })
    }catch (err){}
    let fetchItens=false;
    if (!this.spaceItens || this.spaceItens.length==0){
      fetchItens=true;
    }
    else if (this.item.space!=this.spaceItens[0].space){
      fetchItens=true
    }
    if (fetchItens){
      this.spaceItens=[]
      this.spaceIndex=0
      let ids=0;
      this._companyService.getUserRoomItemRef(this._appData.room.id).where('space','==',this.item.space).get().then(v=>{
        v.forEach(it=>{
          let ite=it.data();
          this.spaceItens.push(ite)
          if (ite.objectId==this.item.objectId){
            this.spaceIndex=ids
          }
          ids++;
        })
      })
    }

    this._appData.npcTriggers=null;
    this._appData.secondTriggers=null;
    this._appData.npcTriggers=null

    this.availablePacks=[]
    for (let pack in this._appData.room.packs){
      this.availablePacks.push(this._appData.room.packs[pack])
    }

    if (this._appData.room.background2d && this._appData.room.background2d.length>0){
      this._appData.webGl=false
    }
    else{
      this._appData.webGl=true      
    }
    //FIX for turning actions in triggers
    if (!this.item.triggers){this.item.triggers={}}
    if (this.item.version<4){

      if (this.item.action){
        this.item.triggers.onClick=[{kind:this.item.action,param:this.item.param}]
        delete this.item.action;
        delete this.item.param;
      }
      if (this.item.closeAction){
        this.item.triggers.onClose=[{kind:this.item.closeAction,param:this.item.closeParam}]
        delete this.item.closeAction;
        delete this.item.closeParam;
      }
      this.item.version = 4;
      this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId.toString()).set(this.item)
    }
    else{
      delete item.action;
      delete item.param;
      delete item.closeAction;
      delete item.closeParam;
      delete item.color;
      delete item.fbx
    }
    //
    this._appData.triggers=item.triggers; 
    this._appData.action=null;
    this._appData.secondAction=null;
    this._appData.secondTriggers=null;
    this._appData.activeSecondTrigger=null
  
    if (document.getElementById('trigger-reload')){
      document.getElementById('trigger-reload').click();
    }
    if (!this.item.orientation) { this.item.orientation = 0; }
    let si = Math.sin(this.item.orientation);
    let co = Math.cos(this.item.orientation)
    if (si >= 0 && co >= 0) {
      this.sitOr = 'SW'
    }
    if (si >= 0 && co < 0) {
      this.sitOr = 'NW'
    }
    if (si < 0 && co >= 0) {
      this.sitOr = 'SE'
    }
    if (si < 0 && co < 0) {
      this.sitOr = 'NE'
    }


    if (!this.loading) {
      let model = this.item.model;
      let size = this.item.size;
      let data = { kind: 'loadItem', url: model, size: size }
      this.sendItemIframeMessage(data)
      setTimeout(() => {
        let orientation = this.item.orientation
        if (!orientation) {
          orientation = Math.PI / 4
        }
        this.item.orientation = orientation;
        this.sendItemIframeMessage({ kind: 'rotateItem', angle: item.orientation })
      }, 2000)
    }


    

    this.colours = item.colours

    if (!item.rotation) {
      item.rotation = { x: 0, y: 0, z: 0 }
    }
    if (!item.scale) {
      item.scale = { x: 1, y: 1, z: 1 };
    }

    this.zForm = this.fb.group({
      xIndex: item.position.x,
      yIndex: item.position.y,
      zIndex: item.position.z,
      rxIndex: item.rotation.x,
      ryIndex: item.rotation.y,
      rzIndex: item.rotation.z,
      dxIndex: item.dimension.x,
      dyIndex: item.dimension.y,
      dzIndex: item.dimension.z,
      sxIndex: item.scale.x,
      syIndex: item.scale.y,
      szIndex: item.scale.z,      

      name: item.name
    });

    //pack may be on thumbnail or model
    let split='';
    let pack=null
    if (item.thumbnail){
      split=item.thumbnail.split('-')
      if (split[0]=='pack'){
        pack=split[1]
      } 
    }
    if (item.model){
      split=item.model.split('-')
      if (split[0]=='pack'){
        pack=split[1]
      }
    }
    
    this.selectAvailablePack(pack)

}

  public animateRotation(axis,val){
    if (!this.item.animation){
      this.item.animation={
        rotation:{x:false,y:false,z:false}
      }
    }
    if (!this.item.animation.rotation){
      this.item.animation.rotation={x:false,y:false,z:false}      
    }
    this.item.animation.rotation[axis]=val;
    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId.toString()).set(this.item)
  }
  public makeNew(tab){
    this._appData.memoryItem=this.item;
    let date=new Date();
    let milis=date.getTime().toString();
    if (tab=='icons'){
      this._appData.room.textures[tab].push({id:milis,name:'',i2d:''})
    }
    else if (tab=='models'){

    }
    else{
      this._appData.room.textures[tab].push({id:milis,name:'',url:''})
    }
    this._appData.tabToEdit=tab
    $("#itemManipulationModal").modal('hide')
    $("#editCardMediaModal").modal('show')

    setTimeout(()=>{
      $("#media-modal-reload").click();
    },1000)
  }
  public select2dIcon(img) {
    if (this.icons[img].id=='NEWICON'){
      this.makeNew('icons')
      return
    }
    let prefix=this.selectedPack ? 'pack-'+this.selectedPack.id+'-' : ''
    let media=this.icons[img]
    this.item.thumbnail = prefix+'i3d-'+this.icons[img].id
    if (this.selectedPack){
      let modelId=this.selectedPack.icons[img].id
      this.item.thumbnail = prefix+'i3d-'+modelId;
    }
    this.item.rows=media.rows!=null ? media.rows : 0;
    this.item.cols=media.cols!=null ? media.cols : 0;
    this.item.model = null
    let id=0;
    this.icons.forEach(v=>{
      if (id==img){
        v.selected=true
      }
      else{
        v.selected=false;
      }
       id++
    })

    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId.toString()).set(this.item)
    this.sendIframeMessage({kind:'updateMedia',media:media})
    setTimeout(t=>{
     this.sendIframeMessage({ kind: 'updateItem', item: this.item })
    },1000)


  }

  public select2dImage(img) {
    if (this.images[img].id=='NEWIMAGE'){
      this.makeNew('images')
      return
    }

    let prefix=this.selectedPack ? 'pack-'+this.selectedPack.id+'-' : ''
    let media=this.images[img]
    this.item.thumbnail = prefix+'img-'+this.images[img].id
    if (this.selectedPack){
      let modelId=this.selectedPack.images[img].id
      this.item.thumbnail = prefix+'img-'+modelId;
    }
    this.item.rows=media.rows!=null ? media.rows : 0;
    this.item.cols=media.cols!=null ? media.cols : 0;
    this.item.model = null
    let id=0;
    this.images.forEach(v=>{
      if (id==img){
        v.selected=true
      }
      else{
        v.selected=false;
      }
       id++
    })

    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId.toString()).set(this.item)
    setTimeout(t=>{
     this.sendIframeMessage({ kind: 'updateItem', item: this.item })
    },1000)
  }


  
  public setSpace(){
    let space=this._appData.instagramUser.space;
    this.item.space=space;
    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId.toString()).set(this.item)
  }
public selectAnimation(mid) {
    let prefix=this.selectedPack ? 'pack-'+this.selectedPack.id+'-' : ''
    this.item.animation = prefix+'animation-'+mid.id;
    if (this.selectedPack){
      let modelId=this.selectedPack.animation[mid].id
      this.item.animation = prefix+'animation-'+modelId;
    }
    this.animations.forEach(v=>{
      if (v.id==mid.id){
        v.selected=true
      }
      else{
        v.selected=false;
      }
    })
    this.item.text='';
    this.item.fbx='';
    this.item.thumbnail='';
    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId.toString()).set(this.item)
  }
  public selectModel(mid) {
    let prefix=this.selectedPack ? 'pack-'+this.selectedPack.id+'-' : ''
    this.item.model = prefix+'model-'+this.models[mid].id;
    if (this.selectedPack){
      let modelId=this.selectedPack.models[mid].id
      this.item.model = prefix+'model-'+modelId;
    }
    let id=0
    this.models.forEach(v=>{
      if (id==mid){
        v.selected=true
      }
      else{
        v.selected=false;
      }
       id++
    })
    this.item.text='';
    this.item.fbx='';
    this.item.thumbnail='';
    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId.toString()).set(this.item)
  }
  coloursArray = Object.keys(this.colours).map(key => this.colours[key]);

  public changeColor(color, i) {
    let c = $('#itemcolor' + i).val();
    let rgb = this.hexToRgb(c);
    this.item.colours[i].value = 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')'
    this.sendItemIframeMessage({ kind: 'changeColour', colours: this.item.colours })
    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId.toString()).set(this.item).then(val => {
    });
  }

  public hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  public searchImages() {
    /*
    this._walletService.getUserNFTs().subscribe(val=>{
      let vet=val.json();
      let recipe='recipe-'+this._appData.object.recipeId
      vet.forEach(element => {
        if (element.uri.indexOf(recipe)>0){
          this._walletService.getProperties({src:element.uri}).subscribe(vv=>{
            let ht=vv.json();
            this.images.push(ht);
          })
        }
      });
    })
    */

  }
  public removeItem() {
    let item = this._appData.object;
    Swal.fire({
      title: 'Remover para Lixeira:',
      message: ' Confirme se realmente quer remover para lixeira. Esse item será perdido para sempre.',
      confirmButtonText: 'Remover',
      cancelButtonText: "Cancelar",
      showCancelButton: true,
      focusConfirm: false,
    }).then((result) => {
      if (result.dismiss == 'backdrop') { }
      else if (result.dismiss == 'cancel') {
        //sair
      }
      else if (result.value) {
        this._companyService.getUserRoomItemRef(item.room).doc(this._appData.object.objectId).delete();
        this.sendIframeMessage({ kind: 'removeItem', item: item })
        $('#itemManipulationModal').modal('hide')

      }
    })

  }

  public dinamizeItem() {
    let object = this._appData.object;
    let objectId = object.objectId.toString();
    let roomId = this._appData.room.id.toString()
    this._companyService.getUserRoomItemRef(roomId).doc(objectId).get().then(obj => {
      let dbitem = obj.data()
      let object = dbitem;
      object.static = false;
      this._companyService.getUserRoomItemRef(roomId).doc(objectId).set(object)
      delete object.userReference;
      this.sendIframeMessage({ kind: 'updateItem', item: object })
      $('#itemManipulationModal').modal('hide')
    })

  }
  public statizeItem() {
    let object = this._appData.object;
    let objectId = object.objectId.toString();
    let roomId = this._appData.room.id.toString()
    Swal.fire({
      title: this.translate.instant('ITEM_EDIT_31'),
      text: this.translate.instant('ITEM_EDIT_32'),
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText: this.translate.instant('CANCEL'),
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
    }).then((result) => {
      if (result.dismiss == 'backdrop') { }
      else if (result.dismiss == 'close') { }
      else if (result.dismiss == 'cancel') { }
      else {
        this._companyService.getUserRoomItemRef(roomId).doc(objectId).get().then(obj => {
          let dbitem = obj.data()
          let object = dbitem;
          object.static = true;
          this._companyService.getUserRoomItemRef(roomId).doc(objectId).set(object).then(v => {
            delete object.userReference;
            this.sendIframeMessage({ kind: 'updateItem', item: object })
            $('#itemManipulationModal').modal('hide')
            Swal.fire({ title: this.translate.instant('ITEM_EDIT_33'), text: this.translate.instant('ITEM_EDIT_34') })

          })
        })

      }
    });
  }

  public collectItem() {

    if (this._appData.object.noCollect) {
      if (this._appData.object.owner != this._appData.instagramUser) {
        Swal.fire({ title: this.translate.instant('ITEM_EDIT_35'), text: this.translate.instant('ITEM_EDIT_36') })
      }
    }

    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this._appData.object.objectId.toString()).get().then(obj => {
      let dbitem = obj.data()
      this._appData.object.name = dbitem.name;
      if (dbitem.owner == this._appData.instagramUser.uid) {//item é meu
        //no need for transaction only db manipulation.
        dbitem.room = '';
        dbitem.location = 'bag'
        this._companyService.getUserContainerRef().doc(dbitem.objectId.toString()).set(dbitem).then(val => {
          this._companyService.getUserRoomItemRef(this._appData.room.id).doc(dbitem.objectId.toString()).delete();
          Swal.fire({ title: this.translate.instant('SUCCESS'), text: this.translate.instant('ITEM_EDIT_37') })
          this._companyService.getUserContainer(true)
          this._appData.stream = ''
        })

      }
      else {//item nao é meu
        Swal.fire({
          title: this.translate.instant('ITEM_EDIT_38'),
          text: this.translate.instant('ITEM_EDIT_39'),
          imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
          showConfirmButton: false
        })
        this._companyService.getUserRoomItemRef(this._appData.room.id).doc(dbitem.objectId.toString()).delete();
        let owner = dbitem.owner;
        let idFrom = this._appData.event.id.toString();
        let kindFrom = 'event'
        if (dbitem.admin) {//item criado em empresa
          idFrom = owner
          kindFrom = 'company'
        }
        else if (owner) {
          idFrom = owner
          kindFrom = 'user'
        }
        dbitem.room = '';
        dbitem.location = 'bag';
        this._walletService.makeTokenTransfer(idFrom, kindFrom, this._appData.instagramUser.uid, 'user', dbitem.tokenId, 1, dbitem, owner, kindFrom + '-container', this._appData.instagramUser.uid, 'user-container').subscribe(res => {
          Swal.close()
          if (res.status == 200) {
            Swal.fire({ title: this.translate.instant('SUCCESS'), text: this.translate.instant('ITEM_EDIT_40') })
            setTimeout(() => {
              this._companyService.getUserContainer(true);
            }, 3000)
          }
          else {
            //put item back so others can get it
            dbitem.room = this._appData.room.id;
            dbitem.location = 'ground';
            this._companyService.getUserRoomItemRef(this._appData.room.id).doc(dbitem.objectId.toString()).set(dbitem)
            Swal.fire({ title: this.translate.instant('FAIL'), text: "Ocorreu um problema ao tentar coletar o item e ele voltou pro local original" })
          }
          this._appData.object = null;
          $('#itemManipulationModal').modal('hide')
        }, err => {
          Swal.close()
          dbitem.room = this._appData.room.id;
          dbitem.location = 'ground';
          this._companyService.getUserRoomItemRef(this._appData.room.id).doc(dbitem.objectId.toString()).set(dbitem)
          Swal.fire({ title: this.translate.instant('FAIL'), text: this.translate.instant('ITEM_EDIT_41') })
        })




      }
    })


  }
  public addItem() {
    this._companyService.getRecipesRef(this._appData.event).get().then(val => {
      let recipes = []
      let recipeName = []
      val.forEach(doc => {
        let recipe = new RecipeBean();
        recipe.parse(doc.data());
        recipes.push(recipe)
        recipeName.push(recipe.name)
      })
      Swal.fire({
        title: 'Selecione objeto de receita para adicionar na sua mochila',
        input: 'select',
        inputOptions: recipeName,
        inputPlaceholder: 'Selecionar receita',
        showCancelButton: true,
        inputValidator: (value) => {
          let recipe = recipes[value]
          console.log(recipe)
          let item = {
            objectId: recipe.id,
            event: this._appData.event.id,
            kind: recipe.kind,
            name: recipe.name,
            quantity: 1,
            thumbnail: recipe.thumbnail,
          }
          if (recipe.action) {
            item['action'] = recipe.action;
          }
          if (recipe.thumbnailAnimation) { item['thumbnailAnimation'] = recipe.thumbnailAnimation }
          if (recipe.thumbnailRow) { item['thumbnailRow'] = recipe.thumbnailRow }
          if (recipe.thumbnailColumn) { item['thumbnailColumn'] = recipe.thumbnailColumn }

          //see if i have this item in the quantity
          let hasitem = this._appData.userEventContainer.filter(val => {
            return val.objectId == item.objectId
          })
          if (hasitem && hasitem[0]) {
            item = hasitem[0];
            item.quantity = item.quantity + 1;
          }
          this._companyService.addToUserContainer(this._appData.instagramUser, item).then(val => {
            if (item.quantity == 1) {
              this.list.unshift(item)
            }
            this._appData.userEventContainer = this.list;
          })


        }

      })
    })


  }
  public shareItem() {
    let date = new Date();
    let time = date.getTime();
    let name = this._appData.instagramUser.full_name;
    let notification = {
      event: this._appData.event.id,
      time: time,
      senderUid: this._appData.instagramUser.uid,
      senderName: name,
      senderThumbnail: '',
      subject: 'Convite para ver objeto',
      message: name + ' gostaria de compartilhar um link contigo. Você aceita?',
      kind: 'seeLink',
      link: this._appData.object.param.link,
      read: false,
      action: '',
      answer: ''
    }

    if (this._appData.page == 'meeting') {
      this._companyService.addRoomNotification(this._appData.room, notification)
    }
    else {
      if (this._appData.localConference) {
        this._appData.localConference.forEach(element => {
          if (element.uid == this._appData.instagramUser.uid) {
            Swal.fire({
              title: "Ver item compartilhado",
              text: "Você deseja ver o item que acabou de compartilhar?",
              confirmButtonText: 'Ver',
              cancelButtonText: 'Fechar',
              showCancelButton: true,
              showCloseButton: true,
            }).then((result) => {
              if (result.value) {
                //abrir celular no espaco
                this._companyService.openExternalLink(notification.link, false)

              }
            })
          }
          else {
            this._companyService.sendNotificationToSomeoneElse(this._appData.event, this._appData.instagramUser, element, notification.subject, notification.message, 'seeLink', notification.link, false)
          }
        });
      }
      else {
        this.sendIframeMessage({ "kind": "shareItemToUsers", "item": this._appData.object })
      }
    }

  }
  public updateZ() {
    let item = this._appData.object;
    let x: number = this.zForm.controls['xIndex'].value;
    let y: number = this.zForm.controls['yIndex'].value;
    let z: number = this.zForm.controls['zIndex'].value;

    let rx: number = this.zForm.controls['rxIndex'].value;
    let ry: number = this.zForm.controls['ryIndex'].value;
    let rz: number = this.zForm.controls['rzIndex'].value;

    let dx: number = this.zForm.controls['dxIndex'].value;
    let dy: number = this.zForm.controls['dyIndex'].value;
    let dz: number = this.zForm.controls['dzIndex'].value;

    let name: string = this.zForm.controls['name'].value;
    
    
    let sx: number = this.zForm.controls['sxIndex'].value;
    let sy: number = this.zForm.controls['syIndex'].value;
    let sz: number = this.zForm.controls['szIndex'].value;



    item.position.x = x;
    item.position.y = y;
    item.position.z = z;

    item.rotation.x = rx;
    item.rotation.y = ry;
    item.rotation.z = rz;

    item.dimension.x = dx;
    item.dimension.y = dy;
    item.dimension.z = dz;
    if (!item.scale) {
      item.scale = { x: 0, y: 0, z: 0 };
    }
    let isnotAnumber = Number(item.scale);
    if (!isNaN(isnotAnumber)) {
      item.scale = { x: 0, y: 0, z: 0 };
    }

    item.scale.x = sx
    item.scale.y = sy
    item.scale.z = sz

    item.name = name;


    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(item.objectId.toString()).set(item);
  }
  public useItem() {
    let item = this._appData.object;
    $('#itemManipulationModal').modal('hide')
    if (item.action == 'sittable') {
      let orientation = "NW"
      switch (item.orientation) {
        case 0: {
          orientation = "SE"
          break
        }
        case 1: {
          orientation = "NE"
          break
        }
        case 2: {
          orientation = "NW"
          break
        }
        case 3: {
          orientation = "SW"
          break
        }
      }
      let it = { "name": item.name, "sit": 'sit' + orientation, "x": item.position.x, "y": item.position.y, "objectId": item.objectId };
      this.sendIframeMessage({ "kind": "sit", "item": it })

    }
    else if (item.action == 'container') {
      $('#containerModal').modal("show")
      $('#containerModalClick').click();
    }
    else if (item.action == 'vehicle') {
      let date = new Date();
      let time = date.getTime();
      let notification = {
        subject: this._appData.instagramUser.uid,
        avatar: item.param.avatar,
        kind: 'updateUserAvatar',
        room: this._appData.room.id,
        date: time
      }
      this._appData.itemUse = item;
      this._companyService.addEventNotification(this._appData.event, notification)
      this.sendIframeMessage({
        kind: 'changeSpeed',
        params: item.param,
      });
    }
    else if (item.action == 'door') {
      let it = new Door();
      it.parse(item);
      it.setAppData(this._appData)
      it.setCompanyService(this._companyService);
      it.setTranslation(this.translate);
      it.useItem();
    }
    else if (item.action == 'openLink' || item.action == 'embed') {
      let param = item.param;
      let link = param.link;
      if (this._appData.instagramUser.uid != item.owner) {
        Swal.fire({
          title: 'Link para uma nova janela',
          showCloseButton: true,
          text: "Este objeto está conectado a um link externo. Você gostaria de visitar esse website?",
          confirmButtonText: "ir",
          preConfirm: () => {
            this._companyService.openExternalLink(param.link, true);
          }
        });
      }
      else {
        Swal.fire({
          title: 'Link para uma nova janela',
          showCloseButton: true,
          text: "Este objeto está conectado a um link externo. Você gostaria de visitar esse website ou remover esse link?",
          confirmButtonText: "ir",
          cancelButtonText: "remover",
          showCancelButton: true,
          focusConfirm: false,
        }).then((result) => {
          if (result.dismiss == 'backdrop') { }
          else if (result.dismiss == 'close') { }
          else if (result.dismiss == 'cancel') {
            item.param.link = "";
            item.action = ""
            this._companyService.getUserRoomItemRef(this._appData.room.id.toString()).doc(item.objectId.toString()).set(item)
            this.sendIframeMessage({ kind: 'updateItem', item: item })
          }
          else {
            this._companyService.openExternalLink(param.link, true);
          }
        });

      }
    }
    else if (item.action == 'key') {
      let canManipulate = false;
      this._walletService.getDatabaseNFTs().subscribe(dbRet => {
        let nftVet = dbRet.json();
        nftVet.forEach(n => {
          let attributes = n.attributes;
          attributes.forEach(at => {
            let trait = at.trait_type;
            if (trait == "room") {
              let value = at.value;
              if (value == this._appData.room.id) {
                canManipulate = true;
              }
            }
          })
        })
        if (canManipulate) {
          Swal.fire({
            title: 'Manipular Chave',
            text: 'Você deseja manipular essa chave associando a esta sala?',
            confirmButtonText: "Conectar Sala",
            cancelButtonText: "Não",
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
          }).then((result) => {
            if (result.dismiss == 'backdrop') { }
            else if (result.dismiss == 'close') { }
            else if (result.dismiss == 'cancel') { }
            else {
              Swal.fire({
                title: 'Conectar Sala',
                text: 'Você deseja conectar como chave-mestra ou chave normal?',
                confirmButtonText: "Chave-Mestra",
                cancelButtonText: "Chave Normal",
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false,
              }).then((result) => {
                if (result.dismiss == 'backdrop') { }
                else if (result.dismiss == 'close') { }
                else if (result.dismiss == 'cancel') {
                  Swal.fire({
                    title: "Digite um nome para esta chave",
                    input: 'text',
                    inputAttributes: {
                      autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Salvar',
                    showLoaderOnConfirm: true,
                    preConfirm: (name) => {
                      if (name) {
                        item.name = name;
                        item.param = {}
                        item.param.room = this._appData.room.id;
                        this._companyService.getUserRoomItemRef(this._appData.room.id).doc(item.objectId).set(item)
                      }
                    }
                  })
                }
                else {
                  Swal.fire({
                    title: "Digite um nome para esta chave",
                    input: 'text',
                    inputAttributes: {
                      autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Salvar',
                    showLoaderOnConfirm: true,
                    preConfirm: (name) => {
                      if (name) {
                        item.name = name;
                        item.param = {};
                        item.param.room = this._appData.room.id;
                        item.param.master = true;
                        this._companyService.getUserRoomItemRef(this._appData.room.id).doc(item.objectId).set(item)
                      }
                    }
                  })
                }

              })
            }
          });
          return;
        }
        if (!canManipulate) {
          this._appData.userEventContainer.forEach(v => {
            //need to find masterpiece key
            if (v.param) {
              if (v.param.room == this._appData.room.id && v.param.master) {
                canManipulate = true;
              }
            }
          })
        }
        if (canManipulate) {
          Swal.fire({
            title: 'Manipular Chave',
            text: 'Você deseja manipular essa chave associando a esta sala?',
            confirmButtonText: "Conectar Sala",
            cancelButtonText: "Não",
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
          }).then((result) => {
            if (result.dismiss == 'backdrop') { }
            else if (result.dismiss == 'close') { }
            else if (result.dismiss == 'cancel') { }
            else {
              Swal.fire({
                title: "Digite um nome para esta chave",
                input: 'text',
                inputAttributes: {
                  autocapitalize: 'off'
                },
                showCancelButton: true,
                confirmButtonText: 'Salvar',
                showLoaderOnConfirm: true,
                preConfirm: (name) => {
                  if (name) {
                    item.name = name;
                    item.param = {};
                    item.param.room = this._appData.room.id;
                    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(item.objectId).set(item)
                  }
                }
              })
            }
          });
        }
        else {
          Swal.fire({ title: "Manipular chave", text: "Você precisa de um titulo de propriedade ou uma chave-mestra da sala onde você se encontra para poder manipular essa chave e conectá-la a esse ambiente." })
        }


      })
    }

    else if (item.action == 'writable') {
      let milis = item.objectId;
      let baseItem = item;
      Swal.fire({
        title: 'Que item deseja criar?',
        html: "<img id='postitImg" + item.objectId + "' src='/assets/game-ui/desk/g31611.png' style='width:50px;height:50px'><img id='docs" + milis + "' src='/assets/game-ui/desk/g31611B.png' style='width:50px;height:50px;margin-left:5px'><img id='excel" + milis + "'  src='/assets/game-ui/desk/g31611C.png' style='width:50px;height:50px;margin-left:5px'><img id='powerpoint" + milis + "' src='/assets/game-ui/desk/g31611D.png' style='width:50px;height:50px;margin-left:5px'><img id='draw" + item.objectId + "' src='/assets/game-ui/desk/g31611E.png' style='width:50px;height:50px;margin-left:5px'>",
        showConfirmButton: false,
        showCancelButton: false,
      })
      $(document).on('click', '#postitImg' + milis, () => {
        baseItem.action = 'embed'
        baseItem.name = 'postit',
          baseItem.thumbnail = 'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2FeventRecipepostit.png?alt=media&token=8b3f49ad-544b-4ab4-b4b8-a229697b1ebe'
        baseItem.param = { link: '', name: 'postit' }
        baseItem.position.x = 10
        baseItem.position.y = 10
        baseItem.position.z = 0
        this._companyService.getUserRoomItemRef(this._appData.room.id).doc(baseItem.objectId).set(baseItem.toDB()).then(val => {
          this.sendIframeMessage({ kind: 'addItem', item: baseItem.toDB() })
          Swal.fire(this.translate.instant('SUCCESS'), 'Seu item foi criado e está disponível para uso')
        });
      });
      $(document).on('click', '#docs' + milis, () => {
        this.makeItem('application/vnd.google-apps.document', 'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Foffice%2Fundefined_1631736382299?alt=media&token=a11531ac-c266-425d-b741-4cd5e1ddbcbb')
      });
      $(document).on('click', '#excel' + milis, () => {
        this.makeItem('application/vnd.google-apps.spreadsheet', 'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Foffice%2Fundefined_1631736939295?alt=media&token=e4a85a00-16eb-47a6-964f-85b78ebc5b04')
      });
      $(document).on('click', '#powerpoint' + milis, () => {
        this.makeItem('application/vnd.google-apps.presentation', 'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Foffice%2Fundefined_1631737637744?alt=media&token=11071148-0f51-4295-b2cb-06929aec7143')
      });
      $(document).on('click', '#draw' + milis, () => {
        this.makeItem('application/vnd.google-apps.drawing', 'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Foffice%2Fundefined_1631737381584?alt=media&token=44280d7f-3f03-433e-9137-49fdd5c10706')
      });






    }
    else {
      if (this._appData.instagramUser.uid != item.owner) {
        Swal.fire({ title: "Item sem ação", text: "Este item não possui ação configurada. Apenas o dono pode configurar." })
      }
      else {
        Swal.fire({
          title: this.translate.instant('CONTAINER_MODAL_42'),
          text: this.translate.instant('CONTAINER_MODAL_43'),
          confirmButtonText: this.translate.instant('CONTAINER_MODAL_45'),
          cancelButtonText: this.translate.instant('CANCEL'),
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
        }).then((result) => {
          if (result.dismiss == 'backdrop') { }
          else if (result.dismiss == 'close') { }
          else if (result.dismiss == 'cancel') {
          }
          else {
            this.makeEmbedProcess(item, null)
          }
        });
      }

    }

  }



  public makeEmbedProcess(item, link) {
    Swal.fire({
      title: this.translate.instant('CONTAINER_MODAL_50'),
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: this.translate.instant('SAVE'),
      showLoaderOnConfirm: true,
      preConfirm: (name) => {
        if (name) {
          Swal.fire({
            title: this.translate.instant('CONTAINER_MODAL_51'),
            input: 'text',
            inputAttributes: {
              autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Salvar',
            showLoaderOnConfirm: true,
            preConfirm: (login) => {
              if (!login) {
                Swal.fire(this.translate.instant('FAIL'), this.translate.instant('CONTAINER_MODAL_52'))
              }
              else {
                item.param.link = login
                if (login.indexOf('http') < 0) {
                  login = 'https://www.' + login;
                }
                item.param.name = name;
                item.name = name;
                item.action = "openLink"
                this._companyService.getUserRoomItemRef(this._appData.room.id.toString()).doc(item.objectId.toString()).set(item)
                this.sendIframeMessage({ kind: 'updateItem', item: item })
                let mheight = window.screen.availHeight;
                let mwidth = window.screen.availWidth;
                let width = mwidth * 60 / 100;
                let height = mheight * 60 / 100;
                let top = mheight * 0.1
                let left = mwidth * 0.1
                window.open(login,
                  'targetWindow',
                  'toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left);
              }

            }
          });


        }
      }
    })
  }

  public setOnInit(v){
    if (v){
      this.item.param.onInit=this.item.position;
    }
    else{
      delete this.item.param.onInit;
    }
    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId.toString()).set(this.item).then(val => {})
  }
  public makeItem(type, thumbnail) {
    //entrar
    Swal.fire({
      title: 'Selecione o nome do arquivo',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Salvar',
      showLoaderOnConfirm: true,
      preConfirm: (login) => {
        if (!login) {
          Swal.fire('Erro..', 'Selecione um nome pro arquivo')
        }
        else {
          let fileName = login;
          Swal.fire({
            title: 'Criando seu arquivo',
            html: 'Estamos criando seu arquivo. Isso pode demorar um pouco então por favor pedimos que você aguarde com o browser ligado. Ao final do processo o seu arquivo vai aparecer na área de trabalho.',
          })
          this._companyService.addNewFileToDrive(this._appData.instagramUser.uid, type, fileName).then(
            (val) => {
              let date = new Date();
              let milis = date.getTime()
              let baseitem = new ItemBean();
              baseitem.event = this._appData.event.id.toString(),
                baseitem['param'] = { link: val, name: fileName },
                baseitem.name = fileName,
                baseitem.quantity = 1,
                baseitem.recipeId = '1628517247776'
              baseitem.thumbnail = thumbnail,
                baseitem.objectId = milis.toString();
              baseitem.room = this._appData.room.id;
              baseitem.position.x = 10;
              baseitem.position.y = 10;
              baseitem.position.z = 0;
              this._companyService.getUserRoomItemRef(this._appData.room.id).doc(baseitem.objectId).set(baseitem.toDB()).then(val => {
                this.sendIframeMessage({ kind: 'addItem', item: baseitem.toDB() })
                Swal.fire(this.translate.instant('SUCCESS'), 'Seu item foi criado e está disponível para uso')
              });
            })
        }
      }
    })


  }
  public changeIcon() {

    this._companyService.getTextures('office').get().then(val => {
      //        this.images=[]
      val.forEach((thumb) => {
        let t = thumb.data()
        //        this.images.push(t.thumbnail)
      })
    })
  }

  public selectItemVideo(thumbnail, p) {

    for (let i = 0; i < this.itemVideos.length; i++) {
      if (this.itemVideos[i].url == thumbnail) {
        if (p == 'param') {
          this.itemVideos[i].selected = true;
        }
        else {
          this.itemVideos[i].selectedClose = true;
        }
      }
      else {
        if (p == 'param') {
          this.itemVideos[i].selected = false;
        }
        else {
          this.itemVideos[i].selectedClose = false;
        }
      }
    }
    if (!this.item[p]) {
      this.item[p] = {}
    }
    //remove #t=5
    let idx = thumbnail.indexOf('#t=5')
    if (idx > 0) {
      thumbnail = thumbnail.substring(0, idx);
    }

    this.item[p]['video'] = thumbnail
    if (p == 'param') {
      this.item.action = 'videoShow'
    }
    else {
      this.item.closeAction = 'videoShow'
    }
    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId.toString()).set(this.item).then(val => {
    });


  }
  public selectItemImage(thumbnail,close) {

    for (let i = 0; i < this.itemImages.length; i++) {
      if (this.itemImages[i].url == thumbnail) {
        this.itemImages[i].selected = true;
      }
      else {
        this.itemImages[i].selected = false;
      }
    }
    if (!this.item.param) {
      this.item.param = {}
    }
    if (close=='closeParam'){
      this.item.closeParam['image'] = thumbnail
      this.item.closeAction = 'imageShow'
        
    }
    else{
      this.item.param['image'] = thumbnail
      this.item.action = 'imageShow'
    }
    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId.toString()).set(this.item).then(val => {
    });

  }
  public selectItemAudio(thumbnail, p) {
    for (let i = 0; i < this.itemAudios.length; i++) {
      if (this.itemAudios[i].url == thumbnail) {
        if (p == 'param') {
          this.itemAudios[i].selected = true;
        }
        else {
          this.itemAudios[i].selectedClose = true;
        }
      }
      else {
        if (p == 'param') {
          this.itemAudios[i].selected = false;
        }
        else {
          this.itemAudios[i].selectedClose = false;
        }
      }
    }
    if (!this.item[p]) {
      this.item[p] = {}
    }
    this.item[p]['audio'] = thumbnail
    if (p == 'param') {
      this.item.action = 'audioShow'
    }
    else {
      this.item.closeAction = 'audioShow'
    }
    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId.toString()).set(this.item).then(val => {

    });
  }
  public updateText() {
    let txtParam = this.textForm.controls['txtParam'].value;
    if (!this.item.param) { this.item.param = {} }
    if (txtParam) {
      this.item.param.text = txtParam;
    }
    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId.toString()).set(this.item).then(val => {

    });


  }

  public eraseTexture() {
    this.item.thumbnail = '';
    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId.toString()).set(this.item).then(val => { })

  }
  public rotateItem() {
    let item = this.item;
    const piOver4 = Math.PI / 4;
    let multiple = Math.round(item.orientation / piOver4);
    let radMult = multiple * piOver4;
    let res
    if (Math.abs(radMult) % (Math.PI / 2) === 0) {
      res = (multiple + 1) * piOver4;
    }
    else {
      res = radMult
    }
    radMult = res + Math.PI / 2;
    item.orientation = radMult;
    this.item.orientation = radMult;
    let si = Math.sin(this.item.orientation);
    let co = Math.cos(this.item.orientation)
    if (si >= 0 && co >= 0) {
      this.sitOr = 'SW'
    }
    if (si >= 0 && co < 0) {
      this.sitOr = 'NW'
    }
    if (si < 0 && co >= 0) {
      this.sitOr = 'SE'
    }
    if (si < 0 && co < 0) {
      this.sitOr = 'NE'
    }


    this.sendItemIframeMessage({ kind: 'rotateItem', angle: this.item.orientation })


    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId.toString()).set(this.item).then(val => { })
  }
  public turnRight() {
    let item = this._appData.object;
    this._companyService.getUserRoomItemRef(item.room).doc(item.objectId).get().then(val => {
      let itemdb = val.data();
      if (!itemdb.orientation) itemdb.orientation = "SW";
      switch (itemdb.orientation) {
        case "SW": {
          itemdb.orientation = "SE"
          break;
        }
        case "NW": {
          itemdb.orientation = "SW"
          break;
        }
        case "NE": {
          itemdb.orientation = "NW"
          break;
        }
        case "SE": {
          itemdb.orientation = "NE"
          break;
        }
      }
      this._companyService.getUserRoomItemRef(item.room).doc(item.objectId).set(itemdb)
      this.sendIframeMessage({ kind: 'updateItem', item: itemdb })
    })
  }
  public sendIframeMessage(messageKind) {

		const event = new CustomEvent('angularMessage',{detail:messageKind});
		window.dispatchEvent(event);
  }
  public sendItemIframeMessage(messageKind) {
    let frame = 'itemIframe'
    if (this._appData.focusIframe) {
      frame = this._appData.focusIframe;
    }
    var iframe = document.getElementById(frame);
    if (iframe == null) return;
    var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
    iWindow.postMessage(messageKind, "*");
  }
  public updateItemVersion() {
    let recipe = this.item.recipeId
    this._companyService.getRecipesRef(this._appData.event).doc(recipe).get().then((val) => {
      let rec = val.data();
      let recipeBean = new RecipeBean();
      recipeBean.parse(rec)
      let item = recipeBean.toItem();
      item.objectId = this.item.objectId;
      item.room = this._appData.room.id;
      let pos = this.item.position;
      this.item = item.toDB();
      this.item.position = pos;
      this._companyService.getUserRoomItemRef(item.room).doc(item.objectId.toString()).set(this.item)
    })
  }
  constructor(private fb: FormBuilder, public _appData: AppDataService, public _walletService: WalletService, public translate: TranslationService, private _companyService: CompanyService, public _sanitizer: DomSanitizer, public _router: Router, private _routeParams: ActivatedRoute, private _auth: UserService) {
    var eventMethod = window.addEventListener
      ? "addEventListener"
      : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod === "attachEvent"
      ? "onmessage"
      : "message";

    eventer(messageEvent, (e) => {
      switch (e.data.message) {
        case 'loading': {
          console.log('loading')
          break
        }
        case 'loaded': {
          if (e.data.value == 'item') {
            let model = this.item.model;
            let size = this.item.size;
            let data = { kind: 'loadItem', url: model, size: size }
            this.sendItemIframeMessage(data)
            this.loading = false;
            setTimeout(() => {
              this.sendItemIframeMessage({ kind: 'rotateItem', angle: this.item.orientation })
            }, 2000)

          }
          break
        }
        case 'sendBlob': {
          if (e.data.kind != 'item') {
            return;
          }
          let angle = (e.data.angle) * 1000
          let fixed = angle.toFixed(0)
          let colorchange = '';
          if (!this.item.colours) { this.item.colours = [] }
          this.item.colours.forEach(v => {
            if (v.value) {
              colorchange = colorchange + v.value
            }
          })
          let filename: string = this.item.recipeId + '_' + fixed + '_' + colorchange + '.png';
          this.textInfo = this.translate.instant('ITEM_EDIT_30');
          this.loading = true;
          let pngFile = new File([e.data.value], filename, { type: "image/png" });
          this._auth.uploadToFirebase(pngFile, filename, 'events/1592880902713/rooms/' + this._appData.room.id + '/customItens/').subscribe(snapshot => {
            snapshot.ref.getDownloadURL().then(url => {
              this.loading = false;
              this.item.thumbnail = url;
              this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.item.objectId.toString()).set(this.item)
              this.sendIframeMessage({ kind: 'updateItem', item: this.item })
            })
          })

          break;
        }

      }
    })

  }
  public saveNewItemTexture() {
    let data = { kind: 'saveItem' }
    this.sendItemIframeMessage(data)
  }

  public makeNPC(){
    let domain='https://liveplanet.app.br'
    let url=domain+'/avatar?uid='+this._appData.instagramUser.uid+'&room='+this._appData.room.id+'&npc='+this.item.objectId;
    window.location.replace(url);
  }

}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/item-manipulation/item-manipulation-modal.ts